import React from "react";
import ButtonComponent from "./ButtonComponent";
const list=["All","Music","Mixes","Dramedy","Arijit Singh","Lo-fi","Bollywood Music","News","Kavi Sammelan","Suryaputra Karn","Live","Computer Science"];
const ButtonList=()=> <div className="flex gap-3 overflow-x-auto px-4 py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">{list.map(item=><ButtonComponent key={item} item={item}/>)}</div>;
export default ButtonList;
